export interface Vehicle {
    id: string;
    title: string;
    description: string;
    images: string[];
    category: string;
}

export const vehicles: Vehicle[] = [
    {
        id: "t55",
        title: "T-55",
        
        description: "The T-54 and T-55 tanks are a series of main battle tanks (according to some sources) although not recognized as MBT by Soviet and Russian sources, instead classifying them as medium tanks [1] (the very concept of 'main battle tanks' was applied only to tanks beginning with T-64A, armed with 125-mm tank gun) that were designed in the Soviet Union. The first T-54 prototype appeared in March 1945, just as the Second World War ended. The T-54 entered full production in 1947 and became the main tank for armored units of the Soviet Army, armies of the Warsaw Pact countries, and others. T-54s and T-55s were involved in many of the world's armed conflicts during the late 20th and early 21st century.",
        images: [
            "/img/vehicles/t55/t55.jpg",
            "/img/vehicles/t55/T-55A_Martial_law_Poland.jpg",
            "/img/vehicles/t55/t-55_parade.jpg"
        ],
        category: "Tanks"
    },
    {
        id: "t54",
        title: "T-54",
        
        description: "The T-54 and T-55 tanks are a series of main battle tanks (according to some sources) although not recognized as MBT by Soviet and Russian sources, instead classifying them as medium tanks. (the very concept of 'main battle tanks' was applied only to tanks beginning with T-64A, armed with 125-mm tank gun) that were designed in the Soviet Union. The first T-54 prototype appeared in March 1945, just as the Second World War ended. The T-54 entered full production in 1947 and became the main tank for armored units of the Soviet Army, armies of the Warsaw Pact countries, and others. T-54s and T-55s were involved in many of the world's armed conflicts during the late 20th and early 21st century.",
        images: [
            "/img/vehicles/t54/T-54.jpg",
            "/img/vehicles/t54/t54_bw.jpg",
            "/img/vehicles/t54/t54_old.jpg"
        ],
        category: "Tanks"
    },
    {
        id: "chieftain_mk10",
        title: "Chieftain Mk 10",
        
        description: "The Chieftain FV4201 was the main battle tank of the United Kingdom during the 1960s, 1970s and 1980s. It was one of the most advanced tanks of its era, and at the time of its introduction in 1966 had the most powerful main gun and most effective armour of any tank in the world. The Chieftain also introduced a supine (reclining backwards) driver position, enabling a heavily sloped hull with reduced height. It remained in service until replaced with the Challenger 1.",
        images: [
            "/img/vehicles/chieftain/chieftain.jpg",
            "/img/vehicles/chieftain/chieftain_mk5.jpg",
            "/img/vehicles/chieftain/British_Chieftain_tanks.jpg"
        ],
        category: "Tanks"
    },
    {
        id: "centurion_mk5",
        title: "Mk 5 Centurion",
        
        description: "The Centurion is a British designed tank used throughout post-World War II. It became one of the most widely used tank designs around the world until the 1990s.",
        images: [
            "/img/vehicles/centurion/centurion.jpg",
            "/img/vehicles/centurion/centurion_bw.jpg",
            "/img/vehicles/centurion/centurion_sweden.jpg"
        ],
        category: "Tanks"
    },
    {
        id: "abbot",
        title: "Abbot",
        
        description: "FV433 Field Artillery, Self-Propelled 'Abbot' is the self-propelled artillery variant of the British Army FV430 series of armoured fighting vehicles, using much of the chassis of the FV430 but with a fully rotating turret at the rear housing the 105 mm gun and given the vehicle designation of FV433. Its correct designation was 'Gun Equipment 105mm L109 (Abbot)'; L109 was little used, probably to avoid confusion with 155 mm M109 that entered UK service at about the same time. The name 'Abbot' continued the World War 2 style of naming self-propelled artillery after ecclesiastical titles. The FV433 used a different configuration of power pack to other vehicles in the FV430 series.",
        images: [
            "/img/vehicles/abbot/abbott.jpg",
            "/img/vehicles/abbot/abbot_old.jpg",
            "/img/vehicles/abbot/abbot_back.jpg"
        ],
        category: "Artillery"
    },
    {
        id: "ifv",
        title: "IFV",
        
        description: "IFVs are designed to give direct fire support to the dismounted infantry and therefore have significantly enhanced armament.",
        images: [
            "/img/vehicles/IFV/IFV.jpg",
            "/img/vehicles/IFV/ifv_old.jpg",
            "/img/vehicles/IFV/ifv_modern.jpg"
        ],
        category: "Armored Vehicles"
    },
    {
        id: "fv432_apc",
        title: "FV432 APC",
        
        description: "The FV432 is the armored personnel carrier variant of the British Army's FV430 series of armored fighting vehicles. Since its introduction in the 1960s, it has been the most common variant, being used for transporting infantry on the battlefield. In the 1980s, almost 2,500 vehicles were in use, with around 1,500 now remaining in operation - mostly in supporting arms rather than front-line infantry service.",
        images: [
            "/img/vehicles/432/apc.jpg",
            "/img/vehicles/432/432_old.jpg",
            "/img/vehicles/432/FV_432_APC_of_the_7th_Brigade_Royal_Scots.jpg"
        ],
        category: "Armored Vehicles"
    },
    {
        id: "m16_half_track",
        title: "M16 Half-Track & M45 Quadmount",
        
        description: "The M16 Half-Track with an M45 Quadmount was an armored vehicle used by the United States, the British Empire and the other Allies during World War II and the Cold War.",
        images: [
            "/img/vehicles/half_track/half_track.jpg",
            "/img/vehicles/half_track/halftrack_bw.jpg",
            "/img/vehicles/half_track/halftrack_soldiers.jpg"
        ],
        category: "Armored Vehicles"
    },
    {
        id: "gmv_humvee",
        title: "GMV Humvee",
        
        description: "The Ground Mobility Vehicle (GMV) is a special operations version of the Humvee used by the United States Armed Forces. Its design is mostly based on lessons learnt during Operation Desert Storm.",
        images: [
            "/img/vehicles/humvee_green/humvee_green.jpg",
            "/img/vehicles/humvee_green/humvee_green_beach.jpg",
            "/img/vehicles/humvee_green/humvee_green_desertstorm.jpg"
        ],
        category: "Utility Vehicles"
    },
    {
        id: "humvee",
        title: "Humvee",
        
        description: "The High Mobility Multipurpose Wheeled Vehicle (HMMWV), commonly known as the Humvee, is a four-wheel drive military automobile produced by AM General. It has largely supplanted the roles formerly served by smaller jeeps such as the M151 1⁄4-short-ton (230 kg) MUTT, the M561 'Gama Goat', their M718A1 and M792 ambulance versions, the CUCV, and other light trucks. Primarily used by the United States military, it is also used by numerous other countries and organizations and even in civilian adaptations. The Humvee's widespread use in the Persian Gulf War helped inspire the civilian Hummer automotive marque.",
        images: [
            "/img/vehicles/humvee_tan/humvee_tan.jpg",
            "/img/vehicles/humvee_tan/humvee_tan_parade.jpg",
            "/img/vehicles/humvee_tan/hmmwv.jpg"
        ],
        category: "Utility Vehicles"
    },
    {
        id: "5_ton_truck",
        title: "5-Ton Truck",
        
        description: "The M939 series 5-ton 6×6 truck is a family of United States military logistical transportation trucks which was designed in the late 1970s and has been in service ever since. About 32,000 M939 series trucks are in service. The M939 series is an improved version of the older M809 Truck series of trucks.",
        images: [
            "/img/vehicles/5ton/5ton.jpg",
            "/img/vehicles/5ton/5ton_cargo.jpg",
            "/img/vehicles/5ton/5ton_water.jpg"
        ],
        category: "Utility Vehicles"
    }
]
  